function fixTaskBlockHeight(entries) {
  for (let entry of entries) {
    const newHeight = entry.borderBoxSize[0].blockSize + "px";
    const taskBlock = document.getElementById('task-block-parent');
    if (taskBlock) {
      taskBlock.style.height = newHeight;
    }
  }
}

const downloadBlock = document.getElementById('download-block');
if (downloadBlock) {
  const downloadBlockHe = window.getComputedStyle(downloadBlock).height;
  const resizeObserver = new ResizeObserver(fixTaskBlockHeight);
  resizeObserver.observe(downloadBlock);
}